<template>
  <div>
    <div class="nav-header">
      <div class="nav-left">
        <template v-if="currentPath != '/index'">
          <div class="home_icon" @click.stop="handleBackHome">
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </div>
          <div class="line"></div>
          <div class="date">
            {{ date }}配送的订单 （{{
              currentPath == "/details" ? "商品分拣" : "订单分拣"
            }}）
          </div>
        </template>
      </div>
      <div class="nav-right">
        <div class="user">
          <el-dropdown>
            <div><i class="el-icon-user-solid"></i> <span>我的</span></div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="app-main">
      <div class="mt">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { formatTimestamp } from "@/utils/ruoyi";
import { removeToken } from "@/utils/auth";
export default {
  name: "navHeader",
  data() {
    return {
      date: "",
      currentPath: "",
    };
  },
  created() {
    let timestamp = new Date().getTime();
    this.date = formatTimestamp(timestamp);
    // this.currentPath = this.$route.path;
  },
  watch: {
    $route: {
      handler: function (route) {
        this.currentPath = route.path;
      },
      immediate: true,
    },
  },
  methods: {
    handleBackHome() {
      this.$router.push({ path: "/" });
    },
    logout() {
      removeToken();
      location.href = "/index";
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  padding-top: 50px;
  height: calc(100vh - 50px);
  .mt {
    height: calc(100vh - 70px);
    margin: 20px 0 0;
  }
}
.nav-header {
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  padding: 0 20px;
  box-sizing: border-box;
  .nav-left {
    display: flex;
    align-items: center;

    .home_icon {
      cursor: pointer;
      i {
        font-size: 20px;
        color: #3caa41;
      }
      span {
        font-weight: bold;
        margin-left: 5px;
      }
    }
    .line {
      width: 1px;
      height: 20px;
      background-color: #ccc;
      margin: 0 20px;
    }
    .date {
      font-weight: bold;
    }
  }
  .nav-right {
    .user {
      cursor: pointer;
      span {
        margin-left: 8px;
      }
    }
  }
}
</style>